import type {
  FetchLanguagesDefaultAction,
  FetchLanguagesFulfilledAction,
  FetchLanguagesRejectedAction,
} from "entities/languages/actionTypes";
import { LanguageActionTypes } from "entities/languages/actionTypes";
import type { LanguagePayload } from "entities/languages/types";

export const fetchLanguages = (): FetchLanguagesDefaultAction => ({
  type: LanguageActionTypes.FETCH_ALL,
});

export const fetchLanguagesSuccess = (payload: LanguagePayload): FetchLanguagesFulfilledAction => ({
  type: LanguageActionTypes.FETCH_ALL_FULFILLED,
  payload,
});

export const fetchLanguagesFailure = (): FetchLanguagesRejectedAction => ({
  type: LanguageActionTypes.FETCH_ALL_REJECTED,
});
